<template>
  <div class="homepage">
    <div :class="['logo','animate__animated animate__bounceIn',OutAnimation]">N A I L I V A</div>
    <div :class="['introduction','animate__animated animate__bounceIn',OutAnimation]">
      <p>Nailiva  offers  customizable, </p>
      <p>responsive  nail  art  that' shealthier </p>
      <p>and  more  environmentally  friendly.</p>
    </div>
    <div>
    <el-button round color="#222E60" :class="['enterbutton','animate__animated animate__bounceIn',OutAnimation]" @click="triggerAnimation">Get started</el-button>
    </div>
    <div :class="[BubbleAnimation]">
      <img src="https://static.igem.wiki/teams/5298/assets/bubble-1.png" class="bubble_1" style="right:1vw;height:50vh;bottom:68vh;">
      <img src="https://static.igem.wiki/teams/5298/assets/bubble-2.png" class="bubble_2" style="right:38vw;height:35vh;bottom:73vh;">
      <img src="https://static.igem.wiki/teams/5298/assets/bubble-3.png" class="bubble_3" style="height:40vh;bottom:58vh;">
    </div> 
      <img src="https://static.igem.wiki/teams/5298/assets/monster-1.png" :class="['monsters','hvr-grow',LeftAnimation]" style="height:52vh;">
      <img src="https://static.igem.wiki/teams/5298/assets/monster-2.png" :class="['monsters','hvr-pulse-grow',RightAnimation]" style="right:0;height:62vh">
  </div>
</template>

<script>
export default {
  data() {
    return {
      BubbleAnimation: "",
      LeftAnimation: "",
      RightAnimation: "",
      OutAnimation: "",
      isIntersecting: false, // 标记是否已经滚动到组件
      Played:true
    }
  },
  mounted() {
    // 创建 IntersectionObserver 实例
    this.observer = new IntersectionObserver(this.handleIntersection, {
      threshold: 0.5 
    });
    // 开始观察组件元素
    this.observer.observe(this.$el);
  },
  beforeDestroy() {
    // 停止观察以防内存泄漏
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    triggerAnimation() {
      this.BubbleAnimation = "animate__animated animate__fadeOut"
      this.LeftAnimation = "animate__animated animate__bounceOutLeft"
      this.RightAnimation = "animate__animated animate__bounceOutRight"
      this.OutAnimation = "animate__animated animate__zoomOut"
      this.Played=false
      this.$emit('trigger-parent-animation'); // 通过 $emit 触发父组件的动画事件
    },
    MonstersAnimation() {
      this.LeftAnimation = ""
      this.RightAnimation = ""
    },
    handleIntersection(entries) {
      const entry = entries[0];
      this.isIntersecting = entry.isIntersecting;
      if (this.isIntersecting && !this.Played) {
        this.BubbleAnimation = "animate__animated animate__fadeIn"
        this.LeftAnimation = "animate__animated animate__bounceInLeft"
        this.RightAnimation = "animate__animated animate__bounceInRight"
        this.OutAnimation = "animate__animated animate__bounceIn"
        this.Played = true
        setTimeout(() => {
          this.MonstersAnimation()
        }, 1000);
      }
      else if (!this.isIntersecting) {
        this.Played=false
        this.BubbleAnimation = "animate__animated animate__fadeOut"
        this.LeftAnimation = "animate__animated animate__bounceOutLeft"
        this.RightAnimation = "animate__animated animate__bounceOutRight"
        this.OutAnimation = "animate__animated animate__zoomOut"
      }
    },
  }
}
</script>

<style scoped>
.homepage{
    min-width:100vw;
    min-height:93.5vh;
    overflow: hidden;
    position: relative;
  } 

  .logo{
    font-size: 9vw;
    letter-spacing: 1vw;
    font-family: 'LOGO',sans-serif !important;
    color:#293F89;
    line-height: 9vw;
    margin-top: 22vh;
    text-align:center;
  }

    .introduction{
    font-size: 1.5vw;
    line-height: 2.3vw;
    margin-top: 4vh;
    text-align:center;
    letter-spacing: 0.4vw;
  }

  .enterbutton{
    margin-left: 44vw;
    margin-top: 5vh;
    width:calc(280vw * 80 / 1920);
    min-height:calc(200vw * 30 / 1920);
    font-size: calc(200vw * 13 / 1920)!important;
  }

  .animate__animated.animate__bounceIn {
  --animate-duration: 3s;
}

.monsters{
  position: absolute;
  bottom:0;
}

.bubble_1{
  animation: jumpBoxHandlerUp 1.0s infinite;
  position: absolute;
}

.bubble_2{
  animation: jumpBoxHandlerDown 1.0s infinite;
  position: absolute;
}

.bubble_3{
  animation: jumpBoxHandlerUp 1.0s infinite;
  position: absolute;
}

@keyframes jumpBoxHandlerUp { /* css事件 */
  0% {
    transform: translate(0px, 0px);
  }
  50% {
    transform: translate(5px, 30px); /* 可配置跳动方向 */
  }
  100% {
    transform: translate(0px, 0px);
  }
}

@keyframes jumpBoxHandlerDown { /* css事件 */
  0% {
    transform: translate(0px, 0px);
  }
  50% {
    transform: translate(15px, -30px); /* 可配置跳动方向 */
  }
  100% {
    transform: translate(0px, 0px);
  }
}
</style>